import { theme as antdTheme } from "antd";

const SHARED_COMPONENTS = {
  Checkbox: {
    colorPrimary: "#F45B68",
    colorPrimaryHover: "#cd404c",
    colorPrimaryActive: "#F45B68",
    borderRadius: 4,
    controlHeight: 20,
    size: 16,
  },
  Switch: {
    colorPrimary: "#F45B68",
    colorPrimaryHover: "#cd404c",
    colorPrimaryActive: "#F45B68",
    trackHeight: 26,
    trackMinWidth: 38,
    handleSize: 18,
    borderRadius: 22,
  },
  Input: {
    colorPrimary: "#F45B68",
    colorPrimaryHover: "#cd404c",
    colorPrimaryActive: "#F45B68",
    borderRadius: 8,
    controlHeight: 40,
    fontSize: 13,
  },
  Segmented: {
    borderRadius: 8,
    fontWeightStrong: 500,
    controlHeight: 36,
    itemSelectedBg: "#F45B68",
    itemSelectedColor: "#fff",
  },
};

export const getAppAntdTheme = (themeMode = "light") => {
  const isDark = themeMode === "dark";
  return {
    algorithm: isDark
      ? [antdTheme.defaultAlgorithm, antdTheme.darkAlgorithm]
      : [antdTheme.defaultAlgorithm],
    token: {
      fontFamily: `"Inter", sans-serif`,
      colorPrimary: "#F45B68",
      colorBgBase: isDark ? "#1E1E2D" : "#FFFFFF",
      colorBgContainer: isDark ? "#1E1E2D" : "#FFFFFF",
      colorText: isDark ? "#E1E3EA" : "#181C32",
      colorBorder: isDark ? "#2B2B40" : "#D9D9D9",
    },
    components: {
      ...SHARED_COMPONENTS,
      Checkbox: {
        ...SHARED_COMPONENTS.Checkbox,
        colorBgContainer: isDark ? "#1E1E2D" : "#FFFFFF",
        colorText: isDark ? "#E1E3EA" : "#333333",
        colorTextDisabled: isDark ? "#6D6D80" : "#BDBDBD",
        colorBorder: isDark ? "#3F4254" : "#DDDDDD",
      },
      Switch: {
        ...SHARED_COMPONENTS.Switch,
        handleBg: "#FFFFFF",
        colorText: isDark ? "#E1E3EA" : "#333333",
        colorTextTertiary: isDark ? "#92929F" : "#BDBDBD",
        colorBorder: isDark ? "#3F4254" : "#DDDDDD",
      },
      Input: {
        ...SHARED_COMPONENTS.Input,
        colorBgContainer: isDark ? "#1B1B29" : "#FFFFFF",
        colorText: isDark ? "#E1E3EA" : "#333333",
        colorBorder: isDark ? "#3F4254" : "#DDDDDD",
      },
      Select: {
        colorBgContainer: isDark ? "#1B1B29" : "#FFFFFF",
        colorBgElevated: isDark ? "#1E1E2D" : "#FFFFFF",
        colorText: isDark ? "#E1E3EA" : "#181C32",
        colorTextPlaceholder: isDark ? "#92929F" : "rgba(0, 0, 0, 0.25)",
        colorBorder: isDark ? "#3F4254" : "#D9D9D9",
        optionSelectedBg: isDark ? "rgba(244, 91, 104, 0.2)" : "rgba(244, 91, 104, 0.08)",
      },
      Modal: {
        contentBg: isDark ? "#1E1E2D" : "#FFFFFF",
        headerBg: isDark ? "#1E1E2D" : "#FFFFFF",
        footerBg: isDark ? "#1E1E2D" : "#FFFFFF",
        titleColor: isDark ? "#E1E3EA" : "#181C32",
        colorIcon: isDark ? "#A1A5B7" : "rgba(0, 0, 0, 0.45)",
        colorIconHover: isDark ? "#E1E3EA" : "rgba(0, 0, 0, 0.88)",
      },
      Radio: {
        colorPrimary: "#F45B68",
        colorText: isDark ? "#E1E3EA" : "#181C32",
        colorBgContainer: isDark ? "#1E1E2D" : "#FFFFFF",
      },
      Form: {
        labelColor: isDark ? "#E1E3EA" : "#181C32",
      },
      Button: {
        colorBgContainer: isDark ? "#2B2B40" : "#FFFFFF",
        colorText: isDark ? "#E1E3EA" : "#181C32",
        defaultBorderColor: isDark ? "#3F4254" : "#D9D9D9",
      },
    },
  };
};

export const getLocalAntdTheme = (themeMode = "light", colorPrimary = "#F45B68") => {
  const isDark = themeMode === "dark";
  return {
    algorithm: isDark
      ? [antdTheme.defaultAlgorithm, antdTheme.darkAlgorithm]
      : [antdTheme.defaultAlgorithm],
    token: {
      colorPrimary,
      colorBgContainer: isDark ? "#1E1E2D" : "#FFFFFF",
      colorBgElevated: isDark ? "#1B1B29" : "#FFFFFF",
      colorText: isDark ? "#E1E3EA" : "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: isDark ? "#6D6D80" : "rgba(0, 0, 0, 0.25)",
      colorTextPlaceholder: isDark ? "#92929F" : "rgba(0, 0, 0, 0.25)",
      colorBorder: isDark ? "#3F4254" : "#d9d9d9",
      itemBg: isDark ? "#1E1E2D" : "#ffffff",
      itemInputBg: isDark ? "#1E1E2D" : "#ffffff",
      itemLinkBg: isDark ? "#1E1E2D" : "#ffffff",
      itemActiveBg: isDark ? "#2B2B40" : "#ffffff",
      itemActiveBgDisabled: isDark ? "rgba(255, 255, 255, 0.18)" : "rgba(0, 0, 0, 0.15)",
      itemActiveColorDisabled: isDark ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.25)",
      itemSize: 32,
      itemSizeSM: 24,
      miniOptionsSizeChangerTop: 0,
      colorBgContainerDisabled: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
      colorBgTextActive: "rgb(255, 255, 255)",
      colorBgTextHover: isDark ? "rgba(255, 255, 255, 0.08)" : "rgb(255, 255, 255)",
      colorPrimaryBorder: colorPrimary,
      colorPrimaryHover: colorPrimary,
    },
  };
};
